(() => {
  const config = document.currentScript || document.querySelector('script[data-fbt-title], script[data-fbt-button-label]');
  if (!config) return;

  const titleOverride = config.dataset.fbtTitle || '';
  const labelOverride = config.dataset.fbtButtonLabel || '';
  if (!titleOverride && !labelOverride) return;

  const TITLE_SELECTOR = '.cbb-frequently-bought-title';
  const LABEL_SELECTOR = '.cbb-frequently-bought-add-button span';

  let appLabel = null;
  let queued = false;

  function applyOverrides() {
    queued = false;

    if (titleOverride) {
      document.querySelectorAll(TITLE_SELECTOR).forEach((el) => {
        if (el.textContent.trim() !== titleOverride) el.textContent = titleOverride;
      });
    }

    if (!labelOverride) return;

    document.querySelectorAll(LABEL_SELECTOR).forEach((el) => {
      const text = el.textContent.trim();

      // The first wording the app renders is its resting label. Anything else
      // is a state the app owns — "Added" after a successful add — so only the
      // resting label is replaced and the states are left alone.
      if (appLabel === null && text !== labelOverride) appLabel = text;

      if (text === appLabel) el.textContent = labelOverride;
    });
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(applyOverrides);
  }

  applyOverrides();

  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });
})();
